import zIndex from '@mui/material/styles/zIndex'
import makeStyles from '@mui/styles/makeStyles'
import { appBarHeight } from '../app-toolbar-consumer/style'
import { paidConsumerDesktopNavHeight, paidConsumerMobileNavHeight } from '../app-toolbar-paid-consumer/style'
import { trialBannerHeight } from '../app-toolbar-paid-consumer/navigation/style'

export const useStyles = makeStyles(({ palette, breakpoints, spacing }) => ({
  root: {
    '& .MuiDrawer-paper': {
      zIndex: zIndex.drawer + 1,
      width: '450px',
      height: '715px',
      maxHeight: ({ isPaidConsumer, isMobile, isTrialBannerVisible }) => {
        const navHeight = isPaidConsumer ? (isMobile ? paidConsumerMobileNavHeight : paidConsumerDesktopNavHeight) : appBarHeight
        const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
        return `calc(100vh - ${totalHeight}px - 70px)`
      },
      top: 'auto',
      bottom: '20px',
      right: '20px',
      border: 'none',
      borderRadius: '8px',
      boxShadow: 'rgba(0, 0, 0, 0.04) 0px 2px 4px 0px, rgba(0, 0, 0, 0.08) 0px 4px 20px 0px',
      backgroundColor: palette.background.paper,
      [breakpoints.down('sm')]: {
        width: 'calc(100vw - 40px)',
        maxWidth: 'calc(100vw - 40px)',
        height: ({ isPaidConsumer, isMobile, isTrialBannerVisible }) => {
          const navHeight = isPaidConsumer ? (isMobile ? paidConsumerMobileNavHeight : paidConsumerDesktopNavHeight) : appBarHeight
          const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
          return `calc(100vh - ${totalHeight}px - 40px)`
        },
        maxHeight: ({ isPaidConsumer, isMobile, isTrialBannerVisible }) => {
          const navHeight = isPaidConsumer ? (isMobile ? paidConsumerMobileNavHeight : paidConsumerDesktopNavHeight) : appBarHeight
          const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
          return `calc(100vh - ${totalHeight}px - 40px)`
        },
        top: ({ isPaidConsumer, isMobile, isTrialBannerVisible }) => {
          const navHeight = isPaidConsumer ? (isMobile ? paidConsumerMobileNavHeight : paidConsumerDesktopNavHeight) : appBarHeight
          const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
          return `${totalHeight + 20}px`
        },
        right: '20px',
        bottom: '20px'
      }
    }
  },
  skip: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    '& a': {
      textDecoration: 'none',
      color: 'inherit'
    },
    '& .MuiButton-text': {
      textDecoration: 'none',
      color: 'inherit'
    }
  },
  checklistContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: '60px 32px 32px 32px',
    position: 'relative',
    [breakpoints.down('sm')]: {
      width: '100%',
      padding: '60px 24px 24px 24px'
    }
  },
  checklistContent: {
    width: '100%',
    maxWidth: '420px',
    maxHeight: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.down('sm')]: {
      maxWidth: '100%',
      width: '100%'
    }
  },
  gleapBubble: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '96px',
    height: '48px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(1),
    gap: spacing(1),
    borderRadius: spacing(3),
    cursor: 'pointer',
    zIndex: 1350,
    backgroundColor: palette.grey[800],
    color: palette.getContrastText(palette.grey[800])
  }
}))
